import { useMemo, useState } from "react";

import Editor from "@/design/components/Editor";
import EditorList from "@/design/components/EditorList";
import EditorSidebar from "@/design/components/EditorSidebar";

import { Box } from "@mui/material";
import PropTypes from "prop-types";

import OptionButton from "./OptionButton";
import OptionForm from "./OptionForm";

function OptionEditor({ ivr, ivrDispatch }) {
  const [activeIvrOption, setActiveIvrOption] = useState(null);

  // Line key list
  const ivrOptionList = useMemo(() => {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((input) => {
      const optionItem = ivr.options.find((_option) => _option.input === input);

      if (optionItem) {
        return optionItem;
      } else {
        return {
          input,
        };
      }
    });
  }, [ivr.options]);

  return (
    <Editor title="Options" id="optionsEditorCard">
      <Box>
        <EditorList columns={2} rows={5} direction="column">
          {ivrOptionList.map((ivrOption) => (
            <OptionButton
              key={`${ivrOption.input}-${ivrOption.id}`}
              ivr={ivr}
              ivrOption={ivrOption}
              activeIvrOption={activeIvrOption}
              setActiveIvrOption={setActiveIvrOption}
              ivrDispatch={ivrDispatch}
            />
          ))}
        </EditorList>
      </Box>
      <EditorSidebar showForm={!!activeIvrOption}>
        <OptionForm key={activeIvrOption?.input} ivrOption={activeIvrOption} ivr={ivr} ivrDispatch={ivrDispatch} />
      </EditorSidebar>
    </Editor>
  );
}

OptionEditor.propTypes = {
  ivr: PropTypes.object,
  ivrDispatch: PropTypes.func,
};

export default OptionEditor;
